export default __webpack_public_path__ + "static/media/location-pin-icon.1205093b.svg";